import {useAccount} from "../../Accounts.tsx";
import {SendEmailForm} from "./SendEmailsPage.tsx";
import {useEffect, useState} from "react";
import {Email, eventerConsoleApiClient} from "../../../../../api-client/EventerConsoleApiClient.ts";
import {Box, Chip, Divider, Paper, Stack, Typography} from "@mui/material";

interface PreviewStepProps {
    form: SendEmailForm,
    finish: (cancel: boolean) => void,
}

export function PreviewStep(props: PreviewStepProps) {

    const account = useAccount()

    const [email, setEmail] = useState<undefined | Email>()

    useEffect(() => {

        let active = true

        let emailPromise: Promise<Email>
        if (props.form.type === "info") {
            emailPromise = eventerConsoleApiClient.generateInfoEmail({
                accountId: account.id,
                payload: {
                    emailAddresses: props.form.emailAddresses!!,
                    startDateMin: props.form.startDateMin,
                    startDateMax: props.form.startDateMax,
                },
            })
        } else {
            emailPromise = eventerConsoleApiClient.generateUpdateEmail({
                accountId: account.id,
                payload: {
                    emailAddresses: props.form.emailAddresses!!,
                    dateModifiedMin: props.form.dateModifiedMin,
                },
            })
        }

        emailPromise.then((email) => {
            if (active) {
                setEmail(email)
            }
        })

        return () => {
            active = false
        }

    }, [props.form])

    if (email === undefined) {
        return null
    }

    let emailEls = email?.to
        ?.map((emailContact) =>
            <Chip label={emailContact.email} key={emailContact.email} sx={{margin: "2px"}}></Chip>
        )

    return (
        <>
            <Paper
                elevation={3}
                sx={{
                    padding: 2,
                    marginTop: 1,
                }}
            >
                <Stack spacing={1}>
                    <Box>An: {emailEls}</Box>
                    <Divider/>
                    <Typography sx={{paddingTop: 1}} variant={"h5"}>
                        {email.subject}
                    </Typography>
                    <Typography component="div" variant="body2">
                        <div dangerouslySetInnerHTML={{__html: email.message || ""}}/>
                    </Typography>
                </Stack>
            </Paper>
        </>
    )
}